<script>
export default {
  props: {
    user: {},
    automation: {},
    sendings: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  created () {
    this.getStats();

    Bus.$on('bulldeskHashChanged', (hash) => {
      if (hash == 'details') {
        this.getStats();
      }
    });
  },

  data () {
    return {
      loading: true,
      stats: {
        leads: {
          active: 0,
          total: 0,
        },
        actions: {
          total: 0,
          mail: {
            opened: 0,
            clicked: 0,
            replied: 0,
            dropped: 0,
            bounced: 0,
            delivered: 0,
            complained: 0,
          },
        },
      },
    };
  },

  methods: {
    getStats () {
      this.$http.get(`/automation/${this.automation.id}/stats`)
        .then(({ data: stats }) => {
          this.stats = stats;
        })
        .finally((response) => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <section class="automation-stats">
    <div class="automation-stats__header">
      <div class="automation-stats__header-item">
        <p>
          <i
            class="fa fa-circle-o-notch fa-spin"
            v-if="loading"
          /><span
            class="automation-stats--green"
            v-else
          >{{ stats.leads.active | number(0) }}</span>
        </p>
        <h4>{{ __('Leads ativos') }}</h4>
      </div>
      <div class="automation-stats__header-item">
        <p>
          <i
            class="fa fa-circle-o-notch fa-spin"
            v-if="loading"
          /><span v-else>{{ stats.leads.total | number(0) }}</span>
        </p>
        <h4>{{ __('Total de leads') }}</h4>
      </div>
      <div class="automation-stats__header-item">
        <p>
          <i
            class="fa fa-circle-o-notch fa-spin"
            v-if="loading"
          /><span v-else>{{ stats.actions.total | number(0) }}</span>
        </p>
        <h4>{{ __('Ações executadas') }}</h4>
      </div>
    </div>
    <AutomationSendings
      class="automation-stats__section"
      :user="user"
      :automation="automation"
      v-if="sendings"
    />
    <h3 class="automation-stats__title">
      {{ __('Entrega de E-mails') }}
    </h3>
    <div class="row automation-stats__section">
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/sent.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span v-else>{{ stats.actions.mail.total | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('ENVIADOS') }}<span v-if="!loading">100%</span>
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/rejected.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span
                class="automation-stats--red"
                v-else
              >{{ stats.actions.mail.dropped | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('REJEITADOS') }}<span v-if="!loading">{{ stats.actions.mail.dropped / stats.actions.mail.total | percent }}</span>
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/delivered.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span
                class="automation-stats--green"
                v-else
              >{{ stats.actions.mail.delivered | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('ENTREGUES') }}<span v-if="!loading">{{ stats.actions.mail.delivered / stats.actions.mail.total | percent }}</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <h3 class="automation-stats__title">
      {{ __('Engajamento') }}
    </h3>
    <div class="row automation-stats__section">
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/open.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span v-else>{{ stats.actions.mail.opened | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('ABERTOS') }}<span v-if="!loading">{{ stats.actions.mail.opened / stats.actions.mail.delivered | percent }}</span>
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/clicked.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span
                class="automation-stats--red"
                v-else
              >{{ stats.actions.mail.clicked | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('CLICADOS') }}<span v-if="!loading">{{ stats.actions.mail.clicked / stats.actions.mail.delivered | percent }}</span>
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/replied.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span
                class="automation-stats--green"
                v-else
              >{{ stats.actions.mail.replied | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('RESPONDIDOS') }}<span v-if="!loading">{{ stats.actions.mail.replied / stats.actions.mail.delivered | percent }}</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <h3 class="automation-stats__title">
      {{ __('Desengajamento') }}
    </h3>
    <div class="row automation-stats__section">
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/unsub.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span v-else>{{ stats.actions.mail.unsubscribed | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('DESINSCRITOS') }}<span v-if="!loading">{{ stats.actions.mail.unsubscribed / stats.actions.mail.delivered | percent }}</span>
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="automation-stats__card">
          <img
            class="automation-stats__card-image"
            src="/build/icons/automation/spam.svg"
          >
          <div class="automation-stats__card-body">
            <p class="automation-stats__card-number">
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="loading"
              /><span v-else>{{ stats.actions.mail.complained | number(0) }}</span>
            </p>
            <h4 class="automation-stats__card-title">
              {{ __('MARCADOS COMO SPAM') }}<span v-if="!loading">{{ stats.actions.mail.complained / stats.actions.mail.delivered | percent }}</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
  @import '../../../sass/variables';

  .automation-stats {
    padding: 32px;

    &--green {
      color: $green;
    }

    &--red {
      color: $pink;
    }

    &__header {
      display: flex;
      padding-bottom: 32px;
      justify-content: center;

      &-item {
        display: flex;
        font-size: 50px;
        font-weight: 300;
        align-items: center;
        letter-spacing: -0.75px;
        font-family: 'Montserrat', sans-serif;

        &:not(:first-child) {
          margin-left: 50px;
          padding-left: 50px;
          border-left: 1px solid rgba($gray-dark, .1);
        }

        p {
          margin: 0;
        }

        h4 {
          margin: 0;
          font-size: 13px;
          margin-left: 12px;
          font-weight: 400;
          color: $gray-dark;
        }
      }
    }

    &__title {
      margin-bottom: 12px;
      font-weight: 500;
      letter-spacing: -.27px;
      line-height: 30px;
      font-size: 18px;
    }

    &__section {
      margin-bottom: 50px;
    }

    &__card {
      display: flex;
      padding: 32px 0;
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
      border-radius: 15px;
      background-color: #ffffff;
      align-items: center;
      justify-content: center;

      &-image {
        margin-right: 64px;
      }

      &-number {
        display: block;
        font-size: 50px;
        font-weight: 300;
        line-height: 50px;
        margin: 0;
        letter-spacing: -.75px;
      }

      &-title {
        margin: 0;
        color: $gray-light;
        line-height: 16px;
        font-size: 11px;
        letter-spacing: -.17px;
        line-height: 16px;

        span {
          display: block;
          font-weight: 700;
          color: $gray-dark;
        }
      }
    }
  }
</style>
